// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

// Actions
import connectActions from 'utils/connectActions'
import { patchMeLazy } from 'actions/me'

// Atoms
import { AppProgressActivator } from 'atoms/AppProgress'

// Components
import Fade from '@material-ui/core/Fade'
import { ScrollSection } from 'atoms/ScrollSections'
import StepContainer from './StepContainer'
import StepTitle from './StepTitle'
import StepSpacer from './StepSpacer'
import StepInput from './StepInput'
import StepButton from './StepButton'
import StepParagraph from './StepParagraph'
import WelcomeMessageStepWidget from './WelcomeMessageStepWidget'

const mapActionsToProps = {
  patchMeLazyAction: patchMeLazy,
}

export default
@connectActions(mapActionsToProps, { pure: false })
class OnboardingWelcomeMessageStep extends Component {
  static propTypes = {
    user: PropTypes.object,
    patchMeLazyAction: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
  }

  constructor({ user }) {
    super()
    const { welcomeMessage = '' } = (user && user.business.widgetConfig) || {}
    this.state = { welcomeMessage }
  }

  completeStep = sectionProps => () => {
    const { onSectionActivate, sectionIndex } = sectionProps
    onSectionActivate(sectionIndex + 1)
  }

  saveMessage = (callback = () => {}) => async () => {
    const { patchMeLazyAction, user } = this.props
    if (patchMeLazyAction.isPending) return
    const { widgetConfig } = user.business
    const { welcomeMessage } = this.state
    const userData = {
      business: {
        widgetConfig: {
          ...(widgetConfig || {}),
          welcomeMessage
        }
      }
    }
    await patchMeLazyAction.run({
      params: [userData],
      silent: true,
    })
    callback()
  }

  handleWelcomeMessageChange = (ev) => {
    this.setState({ welcomeMessage: ev.target.value })
  }

  handleWelcomeMessageEnterPress = () => {
    this.saveMessage(this.completeStep)()
  }

  handleFormSubmit = (ev) => {
    ev.preventDefault()
  }

  welcomeMessageInputRef = (input) => {
    this.welcomeMessageInput = input
  }

  renderContent = (sectionProps) => {
    const { isActive } = sectionProps
    const { disabled } = this.props
    const { welcomeMessage } = this.state
    return (
      <StepContainer>
        <form onSubmit={this.handleFormSubmit}>
          <StepTitle>Add a welcome message</StepTitle>
          <StepSpacer small />
          <StepParagraph>
            The best way to grab a user's attention when they land on your site.
            {'\r\n'}
            Say a quick hello or get specific and let them know what you'd like them to do.
            {'\r\n'}
            You can change this message as often as you'd like.
          </StepParagraph>
          <StepSpacer />
          <StepInput
            multiline
            fullWidth
            name="welcomeMessage"
            placeholder="Start typing here…"
            maxLength={512}
            disabled={disabled}
            value={welcomeMessage}
            inputRef={this.welcomeMessageInputRef}
            onChange={this.handleWelcomeMessageChange}
            onBlur={this.saveMessage()}
            onEnterPress={this.handleWelcomeMessageEnterPress}
          />
          <Fade in={isActive}>
            <div>
              <StepSpacer small />
              <StepButton disabled={disabled} onClick={this.completeStep(sectionProps)}>
                { welcomeMessage ? 'next' : 'skip' }
              </StepButton>
            </div>
          </Fade>
        </form>
        <WelcomeMessageStepWidget welcomeMessage={welcomeMessage} />
      </StepContainer>
    )
  }

  render() {
    const { patchMeLazyAction } = this.props
    return (
      <Fragment>
        { patchMeLazyAction.isPending && <AppProgressActivator /> }
        <ScrollSection {...this.props}>
          { this.renderContent }
        </ScrollSection>
      </Fragment>
    )
  }
}
